module.exports = __webpack_public_path__ + "img/period_icon.333ab81f.svg";